import { sendDwh } from 'reactApp/utils/ga';
import { ECategoryGa } from 'reactApp/utils/paymentGa';

export const sendFacesDwh = ({ action, eventCategory = ECategoryGa.toolbar, ...data }): void => {
    sendDwh({ eventCategory, action, dwhData: data });
};
